<template>
  <div class="page-container">
    <div class="page-content">

      <!-- Cabeçalho -->
      <div class="page-header">
        <div class="d-flex align-items-center mb-3">
          <h1 class="text-white"><i class="mdi mdi-file-check"></i> Certidões</h1>
        </div>
      </div>

      <!-- Mensagem de alerta -->
      <div v-if="alertMessage" class="col-12">
        <b-alert show variant="danger">{{ alertMessage }}</b-alert>
      </div>

      <!-- Overlay de loading -->
      <div v-if="loading" class="overlay-modal d-flex align-items-center justify-content-center">
        <b-spinner label="Carregando..."></b-spinner>
      </div>

      <!-- Corpo -->
      <div class="page-body">
        <div class="card bg-light-gray">
          <div class="card-body pt-1">

            <!-- Tabela -->
            <div class="table-responsive">
              <table class="table-v3" role="table" aria-busy="false" aria-colcount="3">
                <thead role="rowgroup">
                  <tr role="row">
                    <th class="nowrap">Identificador</th>
                    <th class="nowrap">Nome</th>
                    <th class="nowrap">Ação</th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                  <tr v-for="(item, idx) in paginatedItems" :key="idx" role="row">
                    <td role="cell" class="font-12">{{ item.identifier }}</td>
                    <td role="cell" class="font-12">
                      <span class="truncate-200" :title="item.name">{{ item.name }}</span>
                    </td>
                    <td role="cell" class="column-size-share font-12">
                      <div class="d-flex align-items-center">
                        <button
                          class="btn btn-action"
                          @click="redirect('edit-certificate', { identifier: item.identifier })"
                          title="Editar"
                        ><i class="fas fa-pen"></i></button>
                        <button
                          class="btn btn-action"
                          @click="redirect('details-certificate', { identifier: item.identifier })"
                          title="Detalhes"
                        ><i class="fas fa-eye"></i></button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginação -->
            <nav aria-label="Paginação">
              <b-pagination
                v-model="currentPage"
                :total-rows="items.length"
                :per-page="perPage"
              ></b-pagination>
            </nav>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import commonsService from "@/services/commons";
import dateFormatter from "@/mixins/dateFormatter";
import commomsHelper from "@/mixins/commomsHelper";

export default {
  name: "list-certificates",
  mixins: [dateFormatter, commomsHelper],
  data: () => ({
    perPage: 10,
    currentPage: 1,
    items: [],
    loading: false,
  }),
  created() {
    this.getCertificates();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.items.length / this.perPage) || 1;
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.items.slice(start, start + this.perPage);
    },
  },
  methods: {
     changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    },
    getCertificates() {
      this.loading = true;
      commonsService
        .insurers({ has_integration: true })
        .then((response) => {
          if (response.data.error) {
            this.alertMessage = response.data.message;
            return;
          }
          this.formatList(response.data);
        })
        .catch(() => {
          this.alertMessage = "Não foi possível recuperar as certidões.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatList(data) {
      this.items = Object.keys(data).map((item) => ({
        identifier: item,
        name: data[item],
      }));
    },
    redirect(routeName, params = null) {
      this.$router.push({ name: routeName, params: params });
    },
  },
};
</script>

<style>
</style>
